"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var LinkedIn = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M18,4 C19.1045695,4 20,4.8954305 20,6 L20,18 C20,19.1045695 19.1045695,20 18,20 L6,20 C4.8954305,20 4,19.1045695 4,18 L4,6 C4,4.8954305 4.8954305,4 6,4 L18,4 Z M8,10 L6,10 L6,17 L8,17 L8,10 Z M12,10 L10,10 L10,17 L12,17 L12,13.5 L12.0068666,13.35554 C12.0795513,12.5948881 12.7203039,12 13.5,12 C14.2796961,12 14.9204487,12.5948881 14.9931334,13.35554 L15,13.5 L15,17 L17,17 L17,13 L16.9949073,12.8237272 C16.9036609,11.24892 15.5976809,10 14,10 C13.3085237,10 12.6716876,10.2339425 12.1643223,10.6269969 L12.0000983,10.7638055 L12,10 Z M7,7 C6.44771525,7 6,7.44771525 6,8 C6,8.55228475 6.44771525,9 7,9 C7.55228475,9 8,8.55228475 8,8 C8,7.44771525 7.55228475,7 7,7 Z" })));
};
LinkedIn.displayName = 'LinkedIn';
exports.default = LinkedIn;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LinkedIn.js.map